import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {Location, LocationStrategy} from '@angular/common';
import {trimLeadingSlashes} from '@app/shared/util/string-util';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
	public readonly language: string;

	constructor(@Inject(LOCALE_ID) private locale: string,
							private location: Location,
							private locationStrategy: LocationStrategy) {
		this.language = locale.substring(0, 2).toLowerCase();
	}

	changeLanguage(targetLanguage: string): void {
		const originalPath = this.location.path(true);
		const originalBase = this.locationStrategy.getBaseHref();
		const targetBase = originalBase.replace(new RegExp(`/${this.language}\/?$`), `/${targetLanguage}/`);
		this.navigateToExternalUrl(targetBase + trimLeadingSlashes(originalPath));
	}

	private navigateToExternalUrl(targetUrl: string): void {
		window.location.href = targetUrl;
	}
}
